import Svg, { ClipPath, Defs, Ellipse, G, Path, Rect } from 'react-native-svg'

export const InvalidCvvIcon = ({ height, width, color = '#ffd9d8' }: { height: any; width: any; color?: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-Invalid_Back">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="Invalid_Back" data-name="Invalid Back" clipPath="url(#clip-Invalid_Back)" accessible={false} tabIndex={-1}>
        <G id="Group_5" data-name="Group 5" transform="translate(-836 -387)" accessible={false} tabIndex={-1}>
          <Rect
            id="Rectangle_858"
            data-name="Rectangle 858"
            width="24"
            height="16"
            rx="2"
            transform="translate(840 395)"
            fill={color}
            accessible={false}
            tabIndex={-1}
          />
          <Rect
            id="Rectangle_860"
            data-name="Rectangle 860"
            width="24"
            height="3"
            transform="translate(840 398)"
            fill="#ffc0be"
            accessible={false}
            tabIndex={-1}
          />
          <Rect
            id="Rectangle_861"
            data-name="Rectangle 861"
            width="9"
            height="1"
            transform="translate(842 404)"
            fill="#fff"
            accessible={false}
            tabIndex={-1}
          />
          <G id="Group_4" data-name="Group 4" transform="translate(-1)" accessible={false} tabIndex={-1}>
            <Ellipse
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="6.5"
              cy="6.5"
              r="6.5"
              transform="translate(855 399)"
              fill="#bc514d"
              accessible={false}
              tabIndex={-1}
            />
            <Path
              id="Path_270"
              data-name="Path 270"
              d="M5.116,2.472l-.192,3.8H4.076l-.192-3.8ZM4.5,6.664a.709.709,0,0,1,.36.092A.681.681,0,0,1,5.112,7a.672.672,0,0,1,.092.348.694.694,0,0,1-.092.352.644.644,0,0,1-.252.248.78.78,0,0,1-.72,0A.644.644,0,0,1,3.888,7.7.694.694,0,0,1,3.8,7.352.672.672,0,0,1,3.888,7a.681.681,0,0,1,.252-.248A.709.709,0,0,1,4.5,6.664Z"
              transform="translate(857 400)"
              fill="#fff"
              accessible={false}
              tabIndex={-1}
            />
          </G>
        </G>
      </G>
    </Svg>
  )
}
